import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import { EpisodeState } from '../types'

const episodeName: Getter<EpisodeState, RootState> = (state) => {
  return state.activeEpisode?.name || ''
}

export default episodeName
